import axios from "axios";

const BASE_URL = "https://camerondigital.com/wp-json/cdc/v1";
export const getCategories = () => {
    try {
        const res = axios.get(`${BASE_URL}/categories`);
        return res;
    } catch (e) {
        console.log("Error getting categories: ", e);
    }
};
export const getProjects = (categories) => {
    // console.log("CATEGORIES ON SERVICES: ", categories);

    try {
        let res;
        if (categories.length > 0) {
            res = axios.get(
                `${BASE_URL}/projects?category=${categories.join(",")}`
            );
        } else {
            res = axios.get(`${BASE_URL}/projects`);
        }
        return res;
    } catch (e) {
        console.log("Error getting projects: ", e);
    }
};
